import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import Button from '../common/Button';
import '../../styles/components/landing/PricingSection.css';

const PricingSection = ({ eyebrow, title, description, plans = [], onSelect }) => {
  if (!plans.length) return null;

  return (
    <section id="pricing" className="ls-pricing">
      <div className="container">
        <div className="ls-pricing__header">
          {eyebrow && <span className="ls-pricing__eyebrow">{eyebrow}</span>}
          <h2 className="ls-pricing__title">{title}</h2>
          {description && <p className="ls-pricing__description">{description}</p>}
        </div>

        <div className="ls-pricing__grid">
          {plans.map((plan, i) => (
            <motion.article
              key={i}
              className={`ls-pricing__card${plan.highlighted ? ' ls-pricing__card--featured' : ''}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
            >
              {plan.highlighted && <span className="ls-pricing__badge">Mais escolhido</span>}
              <h3>{plan.name}</h3>
              <div className="ls-pricing__price">
                <span className="ls-pricing__amount">{plan.price}</span>
                {plan.period && <span className="ls-pricing__period">{plan.period}</span>}
              </div>
              <ul>
                {(plan.features || []).map((f, j) => (
                  <li key={j}>
                    <Check size={18} />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
              <Button
                variant={plan.highlighted ? 'primary' : 'outline'}
                size="large"
                fullWidth
                onClick={() => onSelect && onSelect(plan)}
              >
                {plan.cta || 'Selecionar'}
              </Button>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
